import { APIGet, APIPost, APIPut, APIDelete, APIUrl, AdminType } from "api/protocols";
import { CancelToken } from "axios";
import { ICreditBookTransaction } from "redux/reducers/models/creditBook";
interface IGetCreditBook {
  id?: number | string;
  facility_id?: number;
  customer_id?: number;
  league_id?: string | number;
  tournament_id?: number;
  type?: "credit_book" | "prize_account";
  extended?: boolean;
  closed?: boolean;
  search?: string;
  has_customer?: boolean;
  with_customer?: boolean;
  limit?: number;
  offset?: number;
  customer_type_ids?: number[];
  tag_ids?: number[];
  balance_min?: number;
  balance_max?: number;
  sort_by?: "last_transaction" | "balance" | "title";
  sort_direction?: "asc" | "desc";
}

export interface ICreditBookListItem {
  id: number;
  client_id: number;
  title: string;
  currency: string;
  type: "credit_book" | "prize_account";
  facility_id: number;
  customer_id: number;
  league_id: number;
  tournament_id: number;
  balance: number;
  closed: boolean;
  last_transaction_at?: string | null;
  customer?: {
    id: number;
    full_name: string;
    email: string | null;
    customer_type?: string | null;
    tags?: Array<{ id: number; label: string; colour?: string }>;
  };
}

interface IPostCreditBook {
  title: string;
  type?: "credit_book" | "prize_account";
  facility_id?: number;
  customer_id?: number;
  league_id?: string | number;
  tournament_id?: number;
  currency?: string;
}

interface IPutCreditBook {
  id: number;
  title?: string;
  type?: "credit_book" | "prize_account";
  facility_id?: number;
  customer_id?: number;
  league_id?: string | number;
  tournament_id?: number;
  closed?: boolean;
  currency?: string;
}

interface IPutVariant {
  credit_book_id: number;
  variant_id: number;
}

interface IDeleteVariant {
  credit_book_id: number;
  variant_id: number;
}

interface IGetCreditBookTransactions {
  credit_book_id: number;
  limit: number;
  offset: number;
}

interface IPostAdjustment {
  credit_book_id: number;
  amount: string;
  note?: string;
}
//Get Credit Book
export async function GetCreditBook(params: IGetCreditBook, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/client/credit-book"), params, useGlobalLoader, token);
}

//Post Credit Book
export async function PostCreditBook(params: IPostCreditBook, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/client/credit-book"), params, useGlobalLoader);
}

//Put Credit Book
export async function PutCreditBook(params: IPutCreditBook, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/client/credit-book"), params, useGlobalLoader);
}

//Put Variant
export async function PutCreditBookVariant(params: IPutVariant, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/client/credit-book/variant"), params, useGlobalLoader);
}

//Delete Variant
export async function DeleteCreditBookVariant(params: IDeleteVariant, useGlobalLoader: boolean) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/client/credit-book/variant"), params, useGlobalLoader);
}

//Distribute Credit Book Funds
export async function DistributeCreditBook(params: any, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/client/credit-book/distribute"), params, useGlobalLoader);
}

//GET Credit Book Transactions
export async function GetCreditBookTransactions(params: IGetCreditBookTransactions, useGlobalLoader: boolean) {
  return await APIGet<ICreditBookTransaction[]>(
    APIUrl(AdminType.FacilityAdmin, "/client/credit-book/transaction"),
    params,
    useGlobalLoader,
  );
}

export async function PostAdjustment(params: IPostAdjustment, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/client/credit-book/adjustment"), params, useGlobalLoader);
}
